export const AGREEMENT_CLAUSES = [
  {
    id: 'pro-licensing',
    parts: [
      {
        kind: 'text',
        content:
          'Upon submission of your order, FITRADIO will obtain licenses from the selected Performing Rights Organizations (PROs). By placing an order, you are authorizing FITRADIO to obtain such licenses on your behalf, and you agree to be bound by the terms of each license, which are available here (',
      },
      {
        kind: 'link',
        content: 'https://www.fitradio.com/tos',
        href: 'https://www.fitradio.com/tos',
      },
      { kind: 'text', content: ' and ' },
      {
        kind: 'link',
        content: 'https://www.fitradio.com/privacy',
        href: 'https://www.fitradio.com/privacy',
      },
      { kind: 'text', content: ').' },
    ],
  },
  {
    id: 'agency',
    text: 'You authorize FITRADIO to act as your agent with the PRO. FITRADIO does not sublicense the license to you, the license is issued directly to you from the PRO.',
  },
  {
    id: 'one-year-term',
    text: 'Each PRO license is a one-year term. Once your license has been issued by the PRO, the license cannot be canceled or refunded. By placing your order, you are agreeing to pay for the full one-year term.',
  },
  {
    id: 'installments-liability',
    text: 'For your convenience, FITRADIO allows you to pay for your license in installment payments, however, this shall not affect your liability to pay for the full one-year. In the event you fail to fully pay for your license and any applicable fees, FITRADIO reserves all rights, including but not limited to the right to send your account to a debt collection agency.',
  },
  {
    id: 'fees-disclosure',
    text: 'FITRADIO charges a management fee and processing fee for our services, which include procurement of the license and FITRADIO’s reporting services. You may be able to obtain the license directly from the PRO at a lower cost and without FITRADIO’s fees.',
  },
  {
    id: 'auto-renewal',
    text: 'Each license shall automatically renew at the conclusion of the one-year term, unless you notify us at least 24 hours in advance that you wish to opt-out of renewal.',
  },
  {
    id: 'cpi-increase',
    text: 'The rates charged by the PROs are subject to increase each year based on the consumer price index (CPI). Unless you cancel prior to the renewal, your rate for the renewed license will be the increased rate. FITRADIO will do our best to notify you of the applicable price increase each year to enable you to opt out of renewal prior to the 24-hour deadline. However, ultimately it is your responsibility to be aware of the annual price increase and your renewal deadlines.',
  },
  {
    id: 'no-guarantee',
    parts: [
      {
        kind: 'bold',
        content:
          'FITRADIO does not guarantee any or all of the PROs will issue a license to you. The placement of an order does not guarantee that a license will be issued. Typically, if a PRO refuses to issue a license it is because there is a past due balance owed by the applicant. In the event that your license is denied, or declined, your charges will be refunded and your pass through license with FITRADIO will be canceled.',
      },
    ],
  },
  {
    id: 'no-retroactive-coverage',
    parts: [
      {
        kind: 'bold',
        content:
          'Any license obtained by FITRADIO shall be valid from the date of issuance and shall not cover or prevent liability from past unlicensed use of music. The PROs may still seek to recover past due balances or damages from unlicensed activities that occurred prior to the license issuance.',
      },
    ],
  },
  {
    id: 'accuracy-warranty',
    text: 'FITRADIO obtains the selected licenses from the PRO based on the information that you provide to FITRADIO. By submitting such information you are representing and warranting to FITRADIO and the PROs that this information is accurate and truthful. If FITRADIO and/or the PRO determines the information provided is inaccurate, your rates may be adjusted to reflect the accurate information, you will be liable for any back-fees that are applicable and/or your license may be revoked.',
  },
  {
    id: 'rate-calculation-adjustments',
    text: 'FITRADIO has done its best to calculate these rates based on the information that PROs provide us, from time to time there may be errors and in that event, we will contact you to resolve the issue. We reserve the right to make adjustments to your rate or license in the event your information requires correction.',
  },
  {
    id: 'nsf-fee',
    text: 'FITRADIO reserves the right to levy a $35 fee for failed payments or NSF (Non-Sufficient Funds) occurrences by customers.',
  },
  {
    id: 'membership-reporting-audit',
    text: 'Membership Reporting and Audit Responsibility: Client is solely responsible for providing accurate member counts to FITRADIO on an annual basis, or more frequently if requested. Music licensing fees payable to ASCAP, BMI, SESAC, and GMR are based on these reported counts. The PROs reserve the right to audit membership records at any time. If an audit determines that actual member counts exceeded reported counts, Client shall be fully liable for all additional fees, penalties, or back payments assessed by the PROs, as well as any costs incurred by FITRADIO in connection with such findings. Failure to provide accurate membership counts or to comply with audit requirements may result in suspension or termination of licensing services provided through FITRADIO.',
  },
];

export const renderClauseParts = (parts, LinkWrapper) =>
  parts.map((part, index) => {
    if (part.kind === 'text') return <span key={index}>{part.content}</span>;
    if (part.kind === 'bold') {
      return <strong key={index}>{part.content}</strong>;
    }
    if (part.kind === 'link') {
      const LinkComponent = LinkWrapper || 'a';
      return (
        <LinkComponent key={index} href={part.href} target="_blank" rel="noopener noreferrer">
          {part.content}
        </LinkComponent>
      );
    }
    return null;
  });
